var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qrbox"},[_c('vue-qr',{staticClass:"qrimg",staticStyle:{"display":"block"},attrs:{"colorDark":"black","text":_vm.qrSrc,"dotScale":_vm.dot,"size":300}}),_c('div',{staticClass:"btnlist"},[_c('Button',{attrs:{"type":"primary","shape":"circle"},on:{"click":_vm.saveQrImg}},[_vm._v("保存二维码")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }